import React from "react"
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap"
import classnames from "classnames"
import Flag from 'react-world-flags'
import css from "./LanguageSwitcher.module.css"
import { useStore } from "store"
import { useTranslation } from "react-i18next"

function LanguageSwitcher() {
    const { i18n } = useTranslation();
    const language = useStore(state => state.language)
    const setLanguage = useStore(state => state.setLanguage)

    const languages = [
        { name: "German", code: "de" },
        { name: "English", code: "en" }, 
        { name: "Slovak", code: "sk" }, 
        { name: "Hungarian", code: "hu" }
    ]

    function switchLang(lang) {
        i18n.changeLanguage(lang)
        setLanguage(lang)
    }
    return ( 
        <UncontrolledDropdown className={css.wrapper}>
            <DropdownToggle tag="div" className={classnames("nav-link", css.selectedFlag)}>
                <Flag code={language === "en" ? "gb" : language} /> 
            </DropdownToggle>
            <DropdownMenu right className={classnames(css.dropdownMenu)}>
                {languages.filter(l => l.code !== language).map(l => (
                    <DropdownItem key={l.code} tag="div" className={css.dropdownMenuItem} onClick={() => switchLang(l.code)}><Flag code={l.code === "en" ? "gb" : l.code} className={css.dropdownFlag} />{` ${l.name}`}</DropdownItem>
                ))}
            </DropdownMenu>
        </UncontrolledDropdown>
     );
}

export default LanguageSwitcher;